/* --------------------------------------------------------------------------------------
   routing.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/
import { route } from "preact-router"
import { sessionVar } from "../constants/storage.const"
import { getSessionVar } from "./browserStorage"
import { MFDApp } from "../constants/MFDApp.const"

const isUrlSecured = url => MFDApp.securedRoutes.includes(url)
const onGuestRouteChange = () => getSessionVar(sessionVar.appStarted) || route('/', true)
 
const onSecureRouteChange = () => getSessionVar(sessionVar.sessionId) || route('/', true)
const firstSecuredRoute = MFDApp.securedRoutes[0]

const secureOrGuestRouteChange = url => isUrlSecured(url)? onSecureRouteChange() : onGuestRouteChange()

export const onRouteChange = route => !route.url.includes("xeroxsso")? secureOrGuestRouteChange(route.url) : null
export const routeToLogin = () => route('/login')
export const onAuthSuccess = () => route(firstSecuredRoute)
